import type { ProcessField } from '@shared/types/process';

import type { PropsWithChildren } from 'react';

const fieldSpacing: Partial<Record<ProcessField['typeId'], string>> = {
    Select: 'px-2',
    SelectIdp: 'px-2',
    File: '',
    Date: '',
    DateRange: '',
    String: '',
    Text: '',
    Int: '',
    Float: '',
};

export function ProcessFieldAiChatLayout({
    fieldType,
    children,
}: PropsWithChildren<{ fieldType: ProcessField['typeId'] }>) {
    return (
        <div className={`w-full ${fieldSpacing[fieldType] ?? 'p-4 pb-0'}`}>
            {children}
        </div>
    );
}
